import {APP, GET, POST} from "../util";

const inspectionUrl = "api/seller-payments/initiation/inspection";
const operationUrl = "api/seller-payments/initiation/operation"

const url = {
    inspection: {
        details: `${inspectionUrl}/details/:receivableId`,
        downloadLink: `${inspectionUrl}/download-info/:receivableId`,
    },
    operation: {
        startClearingPayment: `${operationUrl}/start-clearing-payment`,
    }
};

const sellerPaymentsInitiationApi = {
    inspection: {
        getManualTransferDetails: (receivableId) => {
            return GET(url.inspection.details.replace(":receivableId", receivableId));
        },
        getManualPaymentInfoDownloadLink: (receivableId) => {
            return APP.DOMAIN + url.inspection.downloadLink.replace(":receivableId", receivableId);
        }
    },
    operation: {
        startClearingPayment: (params = {}) => {
            return POST(url.operation.startClearingPayment, params);
        }
    }
};

export {
    sellerPaymentsInitiationApi
};